import type { ChangeEventHandler } from "react";

import type { TInputProps } from "@/ui/components/form/Input";
import {
  LOGIN_WITH_CODE_FIELD_CLASS,
  LOGIN_WITH_CODE_SUBMIT_DEFAULTS,
  type TLoginWithCodeInputProps,
  type TLoginWithCodeMessages,
  type TLoginWithCodeSubmitProps,
  type TLoginWithCodeTranslate,
} from "./LoginWithCode.config";
import { cn } from "@/ui/lib/utils";

export const getLoginWithCodeMessages = (
  t: TLoginWithCodeTranslate,
): TLoginWithCodeMessages => ({
  codeLabel: t("codeLabel"),
  codePlaceholder: t("codePlaceholder"),
  submitLabel: t("submitLabel"),
});

export const getLoginWithCodeInputProps = (
  code: TLoginWithCodeInputProps,
  messages: TLoginWithCodeMessages,
): TInputProps => {
  const {
    label,
    onValueChange,
    placeholder,
    ...props
  } = code;

  const onChange: ChangeEventHandler<HTMLInputElement> = (event) => {
    onValueChange(event.target.value);
  };

  return {
    ...props,
    label: label ?? messages.codeLabel,
    name: "loginCode",
    type: "text",
    autoComplete: code.autoComplete ?? "one-time-code",
    inputMode: code.inputMode ?? "numeric",
    placeholder: placeholder ?? messages.codePlaceholder,
    className: cn(LOGIN_WITH_CODE_FIELD_CLASS, props.className),
    onChange,
  };
};

export const getLoginWithCodeSubmitProps = (
  submit: TLoginWithCodeSubmitProps,
  messages: TLoginWithCodeMessages,
) => {
  const {
    label,
    ...props
  } = submit;

  return {
    label: label ?? messages.submitLabel,
    props: {
      ...LOGIN_WITH_CODE_SUBMIT_DEFAULTS,
      ...props,
    },
  };
};
